import { Route, Routes } from "react-router-dom";

import { RequireAuth } from "./lib/auth";
import { Archived } from "./pages/Archived";
import { Ask } from "./pages/Ask";
import { CaptureDetail } from "./pages/CaptureDetail";
import { Login } from "./pages/Login";
import { Places } from "./pages/Places";
import { Tax } from "./pages/Tax";
import { Timeline } from "./pages/Timeline";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Timeline />
          </RequireAuth>
        }
      />
      <Route
        path="/ask"
        element={
          <RequireAuth>
            <Ask />
          </RequireAuth>
        }
      />
      <Route
        path="/archived"
        element={
          <RequireAuth>
            <Archived />
          </RequireAuth>
        }
      />
      <Route
        path="/tax"
        element={
          <RequireAuth>
            <Tax />
          </RequireAuth>
        }
      />
      <Route
        path="/places"
        element={
          <RequireAuth>
            <Places />
          </RequireAuth>
        }
      />
      <Route
        path="/c/:id"
        element={
          <RequireAuth>
            <CaptureDetail />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
